import { Link } from '~/utils/navigation';
import useContextualPathTransformer from '../../hooks/use-contextual-path-transformer.js';
import { insertTrackEvent } from '@comeon/analytics/index.js';
/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {React.MouseEventHandler} [props.onClick]
 * @param {string | object} [props.to]
 * @param {string} [props.href]
 * @param {string} [props.className]
 * @param {object} [props.trackEvent]
 */
function Anchor({ children, onClick, href, to, innerRef, trackEvent, ...rest }) {
	const transformPath = useContextualPathTransformer();
	if (onClick) {
		return (
			<button type="button" style={{ position: 'relative' }} onClick={onClick} {...rest}>
				{children}
			</button>
		);
	}
	if (href) {
		return (
			<a href={href} onClick={trackEvent ? () => insertTrackEvent(trackEvent) : undefined} {...rest}>
				{children}
			</a>
		);
	}
	if (to) {
		return (
			<Link
				onClick={trackEvent ? () => insertTrackEvent(trackEvent) : undefined}
				href={transformPath(to)}
				innerRef={innerRef}
				{...rest}
			>
				{children}
			</Link>
		);
	}
	return null;
}

export default Anchor;
